// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3OIp9","approved":"Status_approved__1wCUz","rejected":"Status_rejected__2iLCg","expired":"Status_expired__1Uvo7","label":"Status_label__1dTRS"};